// GENERATED by scripts/sync-brands.mjs — do not edit by hand.
// Re-run `npm run sync:brands` to refresh from the live explorer.

import type { SnapshotBrand } from "./brands";

export const SYNCED_AT = "2026-09-25T12:31:45.339Z";
export const SOURCE = "https://backend.frak.id/user/merchant/explore";

export const SNAPSHOT: SnapshotBrand[] = [
  {
    "id": "eec25ff7-a30f-47a5-8adc-02bb56ce0f04",
    "name": "Harmo Skincare",
    "slug": "harmo-skincare",
    "domain": "harmo-skincare.fr",
    "reward": 18,
    "logo": "b2c/brands/harmo-skincare-logo.webp",
    "hero": "b2c/brands/harmo-skincare-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/harmo-skincare-hero.webp",
        "width": 1200,
        "height": 675
      }
    ],
    "description": "Duos de soin In&Out : Harmo associe sérums visage et comprimés à croquer. Hydratation, fermeté, éclat en 30 secondes par jour. Fabriqué en France.",
    "palette": {
      "tile": null,
      "ink": "#ff6d4a"
    }
  },
  {
    "id": "f6772b39-85e7-4afe-8bba-38652a92aaff",
    "name": "JE",
    "slug": "je",
    "domain": "jecosmetique.fr",
    "reward": 6,
    "logo": "b2c/brands/je-logo.webp",
    "hero": "b2c/brands/je-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/je-hero.webp",
        "width": 1200,
        "height": 675
      },
      {
        "src": "b2c/brands/je-hero-2.webp",
        "width": 1200,
        "height": 675
      },
      {
        "src": "b2c/brands/je-hero-3.webp",
        "width": 1200,
        "height": 675
      }
    ],
    "description": "Votre peau n'a pas besoin de plus, elle a besoin de mieux. JE propose des soins minimalistes et vivants, à la croisée de la nature, de la science et du geste.",
    "palette": {
      "tile": "#ffffff",
      "ink": "#45a605"
    }
  },
  {
    "id": "f85b1f5b-0ab0-4e54-9ac1-810aa3f2fe43",
    "name": "SAINT LAZARE",
    "slug": "saint-lazare",
    "domain": "saintlazare.fr",
    "reward": 6,
    "logo": "b2c/brands/saint-lazare-logo.webp",
    "hero": "b2c/brands/saint-lazare-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/saint-lazare-hero.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/saint-lazare-hero-2.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/saint-lazare-hero-3.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/saint-lazare-hero-4.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/saint-lazare-hero-5.webp",
        "width": 800,
        "height": 450
      }
    ],
    "description": "Marque engagée qui crée des sacs et accessoires élégants, fabriqués en France par des personnes en situation de handicap, à partir de matières issues de l'upcycling.",
    "palette": {
      "tile": "#ffffff",
      "ink": "#070707"
    }
  },
  {
    "id": "7fad2e9d-0648-4b39-b427-643c83730ce7",
    "name": "Comblée",
    "slug": "comblee",
    "domain": "comblee.com",
    "reward": 10,
    "logo": "b2c/brands/comblee-logo.webp",
    "hero": "b2c/brands/comblee-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/comblee-hero.webp",
        "width": 1000,
        "height": 650
      },
      {
        "src": "b2c/brands/comblee-hero-2.webp",
        "width": 1000,
        "height": 650
      },
      {
        "src": "b2c/brands/comblee-hero-3.webp",
        "width": 1000,
        "height": 650
      }
    ],
    "description": "Comblée, des soins dermo-botaniques fabriqués en France et inspirés par la biodiversité colombienne. Une routine minimaliste pour prendre soin de sa peau avec plaisir 🤍",
    "palette": {
      "tile": "#3a4a20",
      "ink": "#faf6e9"
    }
  },
  {
    "id": "dfafc858-1ed2-4c69-a5bd-b29fbfdfee10",
    "name": "Care By Claudette",
    "slug": "care-by-claudette",
    "domain": "carebyclaudette.com",
    "reward": 8,
    "logo": "b2c/brands/care-by-claudette-logo.webp",
    "hero": "b2c/brands/care-by-claudette-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/care-by-claudette-hero.webp",
        "width": 1024,
        "height": 768
      },
      {
        "src": "b2c/brands/care-by-claudette-hero-2.webp",
        "width": 1024,
        "height": 768
      },
      {
        "src": "b2c/brands/care-by-claudette-hero-3.webp",
        "width": 1024,
        "height": 768
      }
    ],
    "description": "Care By Claudette est une crème de soin pour les ongles. Composée à 99,5% d'ingrédients d'origine naturelle : répare, renforce et nourrit les ongles abîmés. Fabrication française & résultats visibles dès les premiers jours.",
    "palette": {
      "tile": "#f4ece5",
      "ink": "#1c1914"
    }
  },
  {
    "id": "5d85bdd6-76d3-4d8e-8838-8740c1605bf8",
    "name": "Nowa No Water",
    "slug": "nowa-no-water",
    "domain": "nowanowater.com",
    "reward": 5,
    "logo": "b2c/brands/nowa-no-water-logo.webp",
    "hero": "b2c/brands/nowa-no-water-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/nowa-no-water-hero.webp",
        "width": 1200,
        "height": 800
      },
      {
        "src": "b2c/brands/nowa-no-water-hero-2.webp",
        "width": 1200,
        "height": 800
      }
    ],
    "description": "NOWA, la douche sans eau. \nSe nettoyer n'importe où, n'importe quand, même sans eau à disposition.",
    "palette": {
      "tile": null,
      "ink": "#1d1d1b"
    }
  },
  {
    "id": "33980ac2-9640-4e79-b31b-9c1b2bd35c21",
    "name": "Fizimed",
    "slug": "fizimed",
    "domain": "emy.fizimed.com",
    "reward": 6,
    "logo": "b2c/brands/fizimed-logo.webp",
    "hero": "b2c/brands/fizimed-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/fizimed-hero.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/fizimed-hero-2.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/fizimed-hero-3.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/fizimed-hero-4.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/fizimed-hero-5.webp",
        "width": 800,
        "height": 450
      }
    ],
    "description": "Emy, la marque dédiée à la santé intime des femmes.\nRééducation du périnée à domicile avec Emy Trainer, Dispositif Médical Made In Europe.\nEmy Pump Tire-Lait Main Libre Puissance Hospitalière. \nConçus Avec des Professionnels de Santé.",
    "palette": {
      "tile": "#80cbaf",
      "ink": "#2a5c42"
    }
  },
  {
    "id": "5c00633a-7af1-4061-90a1-42df7b748849",
    "name": "Loulenn",
    "slug": "loulenn",
    "domain": "loulenn.fr",
    "reward": 30,
    "logo": "b2c/brands/loulenn-logo.webp",
    "hero": "b2c/brands/loulenn-hero.jpg",
    "heroes": [
      {
        "src": "b2c/brands/loulenn-hero.jpg",
        "width": 1032,
        "height": 688
      },
      {
        "src": "b2c/brands/loulenn-hero-2.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/loulenn-hero-3.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/loulenn-hero-4.webp",
        "width": 800,
        "height": 450
      },
      {
        "src": "b2c/brands/loulenn-hero-5.webp",
        "width": 800,
        "height": 450
      }
    ],
    "description": "LOULENN révèle les incroyables bienfaits de laine de moutons dans une couette extraordinaire : thermorégulatrice, respirante et naturellement anti-acariens. Aussi confortable que désirable. À découvrir en stock ou en précommande.",
    "palette": {
      "tile": "#ffffff",
      "ink": "#b49274"
    }
  },
  {
    "id": "c13ef58b-3629-4dc7-913c-5770fa364a55",
    "name": "oOlution",
    "slug": "oolution",
    "domain": "oolution-eshop.myshopify.com",
    "reward": 10,
    "logo": "b2c/brands/oolution-logo.webp",
    "hero": "b2c/brands/oolution-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/oolution-hero.webp",
        "width": 1200,
        "height": 675
      }
    ],
    "description": "oOlution formule des soins cosmétiques innovants qui stimulent la régénération cellulaire et soutiennent la longévité cutanée. Notre Complexe Bio-Synergie Botanicum™ associe des actifs dermatologiques, botaniques et biotech pour une action synergique mesurée par 7 études cliniques. Soins 100% d'origine naturelle, certifiés BIO et fabriqués en France.",
    "palette": {
      "tile": "#3e5824",
      "ink": "#fefffe"
    }
  },
  {
    "id": "f51c4bec-531d-4929-a96f-4ca746bec9bc",
    "name": "Accalmie",
    "slug": "accalmie",
    "domain": "accalmie-lab.fr",
    "reward": 10,
    "logo": "b2c/brands/accalmie-logo.webp",
    "hero": "b2c/brands/accalmie-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/accalmie-hero.webp",
        "width": 1200,
        "height": 675
      },
      {
        "src": "b2c/brands/accalmie-hero-2.webp",
        "width": 1000,
        "height": 700
      }
    ],
    "description": "Bouillottes de soin aux graines de lin.\n> Made in France\n> Soin naturel et durable\n> Pour toute la famille",
    "palette": {
      "tile": "#ffffff",
      "ink": "#1b4c7d"
    }
  },
  {
    "id": "3177e32e-2548-4a06-a238-1010aa93652f",
    "name": "Divine Harmonie",
    "slug": "divine-harmonie",
    "domain": "divineharmonie.com",
    "reward": 9,
    "logo": "b2c/brands/divine-harmonie-logo.webp",
    "hero": "b2c/brands/divine-harmonie-hero.webp",
    "heroes": [
      {
        "src": "b2c/brands/divine-harmonie-hero.webp",
        "width": 1200,
        "height": 800
      },
      {
        "src": "b2c/brands/divine-harmonie-hero-2.webp",
        "width": 1200,
        "height": 800
      },
      {
        "src": "b2c/brands/divine-harmonie-hero-3.webp",
        "width": 1200,
        "height": 800
      },
      {
        "src": "b2c/brands/divine-harmonie-hero-4.webp",
        "width": 1200,
        "height": 800
      },
      {
        "src": "b2c/brands/divine-harmonie-hero-5.webp",
        "width": 1200,
        "height": 800
      }
    ],
    "description": null,
    "palette": {
      "tile": "#fcfcfc",
      "ink": "#4db6b5"
    }
  }
];
